import { ref, reactive } from 'vue';
import { defineStore } from 'pinia';
import { ICompany } from './company.interface';
import { IStorage } from './storage.interface';


export default defineStore('storage', () => {
  const company = ref<ICompany>(); //state , getter
  function store(prop, value) {  //actions
    if (localStorage.getItem(prop) !== undefined) {
      localStorage.removeItem(prop);
    }
    localStorage.setItem(prop, value);
  }
  function getAll() {
    let all = [];
    let fields = ['planName', 'planType', 'companyNumber', 'companyName', 'email', 'phone', 'name', 'address', 'state'];

    for (const field of fields) {
      // consloe
      all[field] = localStorage.getItem(field);
    }
    return all;
  }
  return { company, store, getAll }
})



// export default defineStore('storage', () => {
//   const storage = reactive<IStorage>({});
//   const isFormValid = ref<boolean>(true);
//   function store(prop, value) {  //actions
//     storage[prop] = value;
//   }

//   function getAll() {
//     return JSON.parse(JSON.stringify(storage));
//   }
//   return { valid: isFormValid, store, getAll }
// })